import * as LosslessJSON from 'lossless-json';

export function prettyJson(json: string): string {
  try {
    return LosslessJSON.stringify(LosslessJSON.parse(json), null, 3);
  } catch (ignored) {
    return json;
  }
}
